/* unplugin-vue-components disabled */import { render } from "./gscpds.vue?vue&type=template&id=3860ed82&scoped=true"
import script from "./gscpds.vue?vue&type=script&lang=js"
export * from "./gscpds.vue?vue&type=script&lang=js"

import "./gscpds.vue?vue&type=style&index=0&id=3860ed82&lang=less&scoped=true"

import exportComponent from "D:\\云盘\\SynologyDrive\\Synology Drive\\文件\\客户调查表\\customweb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3860ed82"]])

export default __exports__